import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Logo } from "@/components/Logo";

import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Search from "@/pages/Search";
import RouteDetail from "@/pages/RouteDetail";
import News from "@/pages/News";
import Dashboard from "@/pages/Dashboard";

function Loading() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background">
      <Logo size={38} />
      <p className="text-sm text-muted-foreground font-mono-plex">Caricamento…</p>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loading />;
  if (!user) return <Navigate to="/accedi" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Emergent Google Auth returns to /dashboard#session_id=... — process it first.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/accedi" element={<Auth />} />
      <Route path="/cerca" element={<Search />} />
      <Route path="/tratta/:id" element={<RouteDetail />} />
      <Route path="/news" element={<News />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
